import {Injectable} from '@angular/core';
import {GoogleTagManagerService} from 'angular-google-tag-manager';
import {GtmTag} from '../models/gtm.model';

@Injectable({
  providedIn: 'root'
})
export class GtmService {
  constructor(private gtmService: GoogleTagManagerService) { }

  pushTag(gtmTag: GtmTag): void {
    this.gtmService.pushTag(gtmTag).then();
  }
}
